$(document).ready(function () {
  // Call function to generate ratings on initial load
  setTimeout(function () {
    generateRatingWithRetry();
  }, 1000);
});

// Object to store ratings for each product
let productRatings = {};

function hashProductId(productId) {
  let hash = 0;
  for (let i = 0; i < productId.length; i++) {
    const char = productId.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

// Main function to generate ratings with retries
function generateRatingWithRetry(attempts = 5) {
  const maxStars = 5;

  const starsContainers = document.getElementsByClassName("stars-container");
  const ratingTexts = document.getElementsByClassName("rating-text");

  // Check if elements are found
  if (starsContainers.length === 0 || ratingTexts.length === 0) {
    if (attempts > 0) {
      // Retry after 500ms if elements are not found
      setTimeout(() => {
        generateRatingWithRetry(attempts - 1);
      }, 500);
    } else {
      console.warn("Elements not found after multiple attempts.");
    }
    return; // Exit the function
  }

  // If elements are found, proceed with the rating generation
  for (let index = 0; index < starsContainers.length; index++) {
    const starsContainer = starsContainers[index];
    const ratingText = ratingTexts[index];

    // Assuming you have a way to identify products, e.g., using a data attribute
    const productId = starsContainer.getAttribute("data-product-id");

    if (starsContainer && ratingText) {
      
      if (productRatings[productId]) {
        const { randomFilledStars, randomRatingsCount } =
          productRatings[productId];

        // Reapply the stored ratings
        renderStarsAndText(
          starsContainer,
          ratingText,
          randomFilledStars,
          randomRatingsCount,
          maxStars
        );
      } else {
        const hash = hashProductId(productId);

        // Generate unique random values for this product if not already stored
        const randomFilledStars = (hash % 2) + 4; // 4 or 5 stars
        const randomRatingsCount = (hash % 401) + 100; // 100-500 ratings

        // Store the generated rating for this product
        productRatings[productId] = { randomFilledStars, randomRatingsCount };

        // Render the stars and text
        renderStarsAndText(
          starsContainer,
          ratingText,
          randomFilledStars,
          randomRatingsCount,
          maxStars
        );
      }
    }
  }
}

// Function to render stars and update the rating text
function renderStarsAndText(
  starsContainer,
  ratingText,
  randomFilledStars,
  randomRatingsCount,
  maxStars
) {
  starsContainer.innerHTML = ""; // Clear any existing stars

  // Create and append stars
  for (let i = 1; i <= maxStars; i++) {
    const star = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    star.setAttribute(
      "class",
      i <= randomFilledStars ? "star full" : "star empty"
    );
    star.setAttribute("viewBox", "0 0 24 24");
    star.setAttribute("width", "15");
    star.setAttribute("height", "14.47");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "M12 2L15 9h8l-6 5 2 8-7-4.5L4 22l2-8L0 9h8L12 2z");

    if (i > randomFilledStars) {
      path.setAttribute("fill", "none");
      path.setAttribute("stroke", "#F4C150");
      path.setAttribute("stroke-width", "2");
    }

    star.appendChild(path);
    starsContainer.appendChild(star);
  }

  // Update rating text with unique stars and ratings count
  ratingText.textContent = `${randomFilledStars}/${maxStars} (${randomRatingsCount}+ ratings)`;
}

// Function to observe changes in the snippet's container
function observeSnippetChanges() {
  const ratingContainer = document.querySelector(".cart-item-count");

  if (!ratingContainer) {
    console.warn("Rating container not found!");
    return;
  }

  // Create a MutationObserver to detect changes in the container
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" || mutation.type === "subtree") {
        // Reapply the stored ratings when changes are detected
        generateRatingWithRetry();
      }
    });
  });

  // Start observing the rating container for changes
  observer.observe(ratingContainer, { childList: true, subtree: true });
}

// Start observing for changes in the rating snippet
observeSnippetChanges();
